<template>
    <!-- Wallet Card -->
    <div class="section pt-1">
        <div class="wallet-card">
            <!-- Balance -->
            <div class="balance">
                <div class="left">
                    <span class="title">വിസ്‌ഡം റിലീഫ് പഴയ ലിസ്റ്റ് [{{ unit.name }}]</span>
                    <h1 class="total text-primary">{{ member_lists.total }}</h1>
                </div>
                <!-- <div class="right">
                    <a :href="'#/org/'+$route.params.sub_level+'/'+$route.params.id+'/relief-entry'" class="button" >
                        <ion-icon name="add-outline"></ion-icon>
                    </a>
                </div> -->
            </div>
            <router-link :to="'/org/'+$route.params.sub_level+'/'+$route.params.id+'/relief-deleted-list'">
                <button type="button" class="btn btn-outline-secondary me-1 mal-text btn-lg col-12 mb-2">
                    നീക്കം ചെയ്ത ലിസ്റ്റ് കാണാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക.
                    <ion-icon name="trash-outline" style="font-size: 60px;"></ion-icon>
                </button>
            </router-link>
        </div>
    </div>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3">
            <h3 class="text-center mt-2 mal-text custom-title">വിസ്‌ഡം റിലീഫ് പഴയ ലിസ്റ്റ്</h3>
        </div>
    </div>
    <div id="search">
        <form class="search-form">
            <div class="form-group searchbox">
                <input type="text" class="form-control" placeholder="ഇവിടെ സെർച്ച് ചെയ്യുക..." v-model="search_qry"
                    @input="getMembersList(1,$event.target.value)">
                <i class="input-icon">
                    <ion-icon name="search-outline"></ion-icon>
                </i>
            </div>
        </form>
    </div>
    <div class="section text-primary" v-if="permissions.result_download">
        <span><a :href="download" :download="'Result'">
                <ion-icon name="download-outline"></ion-icon> Download
            </a></span>
    </div>
    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && member_lists.total <= 0">ഇതുവരെ ആരെയും
            ചേർത്തിട്ടില്ല</h4>
    </div>

    <ul class="listview image-listview inset text mt-2" v-if="!loading_list && member_lists.total > 0">
        <li v-for="(member_list, index) in member_lists.data" v-bind:key="member_list.id">
            <a href="javascript:void(0)" class="item">
                <span class="sl-no">{{ (member_lists.from + index) }}</span>
                <div class="avatar-section">
                    <a href="#">
                        <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="image">
                        <span class="button verified" v-if="member_list.this_year_registered">
                            <ion-icon name="checkmark-outline"></ion-icon>
                        </span>
                        <span class="button not-verified" v-if="!member_list.this_year_registered">
                            <ion-icon name="close-outline"></ion-icon>
                        </span>
                    </a>
                </div>
                <div class="in">
                    <div class="min-width-50">
                        <!-- <header>User</header> -->
                        <b> {{ member_list.family_head_name }} </b>
                        <footer class="text-primary">{{ member_list.family_contact }}
                        </footer>
                    </div>
                    <div class="card-button dropdown">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset' + member_list.id" @click="showActionModel">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                    </div>

                    <!-- Default Action Sheet Inset -->
                    <div class="modal fade action-sheet" :id="'actionSheetInset' + member_list.id" tabindex="-1"
                        role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Action</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">

                                        <li>
                                            <a :href="'tel:' + member_list.family_contact" class="btn btn-list">
                                                <span>
                                                    <ion-icon name="call-outline"></ion-icon> Call
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="canAddOrEditRelief">
                                            <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal" @click="adminEdit(member_list)">
                                                <span>
                                                    <ion-icon name="pencil-outline"></ion-icon> Edit
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="canAddOrEditRelief">
                                            <a href="javascript:void(0)" @click="openTransferModal(member_list)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="swap-horizontal-outline"></ion-icon> Transfer
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="canAddOrEditRelief">
                                            <a href="javascript:void(0)" @click="adminDeleteConfirmation(member_list)"
                                                class="btn btn-list" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="trash-outline"></ion-icon> Remove
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> Cancel
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- * Default Action Sheet Inset -->
                </div>
            </a>
        </li>
    </ul>
    <div class="section mt-2" v-if="!loading_list">
        <vue-awesome-paginate v-if="member_lists.total > 0" :total-items="member_lists.total"
            :items-per-page="member_lists.per_page" :max-pages-shown="3" v-model="member_lists.current_page"
            :on-click="getMembersList" :show-ending-buttons="true" :show-breakpoint-buttons="false" />
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>

    <!-- Transfer Modal (bottom sheet) -->
    <div class="modal fade action-sheet" id="transferModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">Transfer to another Unit</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                    <p v-if="transferMember" class="mb-2">Transfer <b>{{ transferMember.family_head_name }}</b> to:</p>
                    <div class="form-group basic">
                        <label class="label mal-text" for="transfer_district">District</label>
                        <select class="form-control custom-select" v-model="transferDistrict" id="transfer_district"
                            @change="onTransferDistrictChange">
                            <option value="">---Select District---</option>
                            <option v-for="d in transferDistrictsList" :key="d.id" :value="d.id">{{ d.name }}</option>
                        </select>
                    </div>
                    <div class="form-group basic">
                        <label class="label mal-text" for="transfer_zone">Zone</label>
                        <select class="form-control custom-select" v-model="transferZone" id="transfer_zone"
                            @change="onTransferZoneChange">
                            <option value="">---Select Zone---</option>
                            <option v-for="z in transferZonesList" :key="z.id" :value="z.id">{{ z.name }}</option>
                        </select>
                    </div>
                    <div class="form-group basic">
                        <label class="label mal-text" for="transfer_unit">Unit</label>
                        <select class="form-control custom-select" v-model="transferUnit" id="transfer_unit">
                            <option value="">---Select Unit---</option>
                            <option v-for="u in transferUnitsList" :key="u.id" :value="u.id">{{ u.name }}</option>
                        </select>
                    </div>
                    <div class="mt-2">
                        <button type="button" class="btn btn-primary" :disabled="loading || !transferUnit"
                            @click="confirmTransfer">
                            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                            Transfer
                        </button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from "../../services/user.service";
import $ from 'jquery';
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
export default {
    name: 'Admin List',
    components: {
        AlertModel,
        DialogModel
    },
    props: {
        unit_id: null
    },
    data() {
        return {
            loading: false,
            loading_list: false,
            message: "",
            country_code: '91',
            country_code_whatsapp: '91',
            mobile_number: '',
            whatsapp_number: '',
            wing: '',
            stay: '',
            user_level: "",
            sub_levels: [],
            member_lists: [],
            member_list: [],
            member: [],
            member_edit: true,
            orgnal_member_lists: [],
            unit: [],
            editable_id: '',
            editable: false,
            permissions: [],
            add_admin: false,
            abroad_fields: false,
            pin_number: '',
            attendance: 'A',
            attendance_remarks: '',
            search_qty: '',
            member_id: '',
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            attendance_present: [],
            attendance_absent: [],
            filter_wing: '',
            isMember: 'Y',
            isSubscriber: '',
            receipt_no: '',
            subscription_no: '',
            isEdit: false,
            sub_level_name:'',
            download : '',
            search_qry : '',
            transferMember: null,
            transferDistrict: '',
            transferZone: '',
            transferUnit: '',
            transferDistrictsList: [],
            transferZonesList: [],
            transferUnitsList: []
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isOwnUnit() {
            if (!this.currentUser || !this.currentUser.unit_id) return false;
            return String(this.currentUser.unit_id) === String(this.$route.params.id);
        },
        // Allow: specific state editors, district admins on their district's units, zone admins, unit admins, and own unit
        canAddOrEditRelief() {
            if (!this.currentUser) return false;
            const level = parseInt(this.currentUser.user_level);
            const stateEditors = ['9207520344', '9072485752'];
            const userPhone = String(this.currentUser.phone || this.currentUser.mobile || '');
            if (level === 1 && stateEditors.includes(userPhone)) return true;
            if (level === 2) {
                // When viewing at district level route: /org/2/{district_id}/...
                if (String(this.$route.params.sub_level) === '2') {
                    return String(this.currentUser.district_id) === String(this.$route.params.id);
                }
                // When viewing a unit route: /org/4/{unit_id}/...
                if (this.unit && this.unit.district_id) {
                    return String(this.currentUser.district_id) === String(this.unit.district_id);
                }
                return false;
            }
            return this.isOwnUnit || level === 3 || level === 4;
        },
        minusToZero() {
            let value = this.unit.nerpatham_target - this.member_lists.total;
            if (value <= 0) {
                return '0';
            } else {
                return value;
            }
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            this.getMembersList(1);
            this.$root.updateParent('Loading...');
        }
        this.getComboboxValues('COUNTRY_CODE');
        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id
            }
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case 'COUNTRY_CODE':
                            this.country_code_list = response.data.data.list.options;
                            break;
                        case 'UNVERIFIED_REASON':
                            this.verification_status_list = response.data.data.list.options;
                            break;

                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getTextList(event, type) {
            this.message = '';
            let data = {
                q: event,
                type: type,
                filter: 'inside',
                unit_id: this.$route.params.id,
                user_level: this.user_level
            }
            UserService.authPostRequest('get-typehead-values', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_list = response.data.data.list;
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },

        getMembersList(page = 1,search_qry = null) {
            this.loading_list = true;
            let data = {
                user_level: this.user_level,
                unit_id: parseInt(this.$route.params.id),
                search_qry : search_qry?search_qry:''
            }
            UserService.authPostRequest(`get-relief-families?type=old&&page=${page}`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.permissions = response.data.data.permissions;
                        this.download = response.data.data.result_download_url;
                        this.member_lists = response.data.data.list;
                        this.search_qty = '';
                        this.orgnal_member_lists = response.data.data.list.data;
                        this.unit = response.data.data.unit;
                        this.loading_list = false;
                        this.$root.updateParent('വിസ്‌ഡം റിലീഫ് ലിസ്റ്റ്');
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminDeleteConfirmation(admin_list) {
            var data = {
                id: admin_list.id,
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'adminDelete';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        adminDelete(data) {
            UserService.authPostRequest('delete-relief-family', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(1);
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminEdit(member_list) {
            this.$router.push({
                path: '/org/' + this.$route.params.sub_level + '/' + this.$route.params.id + '/relief-entry/' + member_list.id,
                query: {
                    registered: member_list.this_year_registered ? 1 : 0,
                    source: 'old'
                }
            });
        },
        async openTransferModal(member_list) {
            this.transferMember = member_list;
            this.transferDistrict = '';
            this.transferZone = '';
            this.transferUnit = '';
            this.transferZonesList = [];
            this.transferUnitsList = [];
            try {
                const response = await UserService.authPostRequest('get-district-by-id', {});
                this.transferDistrictsList = (response.data && response.data.data && response.data.data.list) || [];
                if (Array.isArray(this.transferDistrictsList) === false) {
                    this.transferDistrictsList = [this.transferDistrictsList];
                }
            } catch (e) {
                this.transferDistrictsList = [];
            }
            $('#transferModal').modal('show');
        },
        async onTransferDistrictChange() {
            this.transferZone = '';
            this.transferUnit = '';
            this.transferUnitsList = [];
            if (!this.transferDistrict) {
                this.transferZonesList = [];
                return;
            }
            try {
                const response = await UserService.authPostRequest('get-zone-by-id', { district_id: parseInt(this.transferDistrict) });
                this.transferZonesList = (response.data && response.data.data && response.data.data.list) || [];
                if (Array.isArray(this.transferZonesList) === false) {
                    this.transferZonesList = [this.transferZonesList];
                }
            } catch (e) {
                this.transferZonesList = [];
            }
        },
        async onTransferZoneChange() {
            this.transferUnit = '';
            if (!this.transferZone) {
                this.transferUnitsList = [];
                return;
            }
            try {
                const response = await UserService.authPostRequest('get-unit-by-id', { zone_id: parseInt(this.transferZone) });
                this.transferUnitsList = (response.data && response.data.data && response.data.data.list) || [];
                if (Array.isArray(this.transferUnitsList) === false) {
                    this.transferUnitsList = [this.transferUnitsList];
                }
            } catch (e) {
                this.transferUnitsList = [];
            }
        },
        async confirmTransfer() {
            if (!this.transferMember || !this.transferUnit) return;
            this.loading = true;
            try {
                const response = await UserService.authPostRequest('transfer-relief-family', {
                    relief_family_id: this.transferMember.id,
                    target_unit_id: parseInt(this.transferUnit)
                });
                if (response.data && response.data.status === 'success') {
                    $('#transferModal').modal('hide');
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message || 'Transfer completed successfully.';
                    this.$refs.alert_model.openModel();
                    this.getMembersList(1);
                } else {
                    this.alert_type = 'Warning';
                    this.alert_message = (response.data && response.data.message) || 'Transfer failed.';
                    this.$refs.alert_model.openModel();
                }
            } catch (err) {
                this.alert_type = 'Error';
                this.alert_message = (err.response && err.response.data && err.response.data.message) || err.message || 'Transfer failed.';
                this.$refs.alert_model.openModel();
            } finally {
                this.loading = false;
            }
        }
    },
};
</script>
<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.listview {
    /* margin-bottom: 20px; */
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.wallet-card {
    padding-bottom: 0px !important;

}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
}
</style>